"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.noDealersFound = exports.getInputMessages = exports["default"] = exports.checkForMobileAgent = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireDefault(require("react"));
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _reactApollo = require("react-apollo");
var _reactRedux = require("react-redux");
var _commonLoader = require("@mmc/common-loader");
var _commonCta = require("@mmc/common-cta");
var _commonLibs = require("@mmc/common-libs");
var _DealerLocatorTools = _interopRequireDefault(require("../js/DealerLocatorTools"));
var propTypes = _interopRequireWildcard(require("./mini-dealer-locator.prop-types"));
var _inputSearchAutocomplete = _interopRequireDefault(require("./input-search-autocomplete"));
var _dealersList = _interopRequireWildcard(require("./dealers-list"));
var _GoogleMapsProvider = _interopRequireDefault(require("../utils/location/googleMaps/GoogleMapsProvider"));
var _useTabs = require("../providers/useTabs/useTabs");
var _searchDealershipsListToggle = _interopRequireDefault(require("./search-dealerships-list-toggle"));
var _useApollo = require("../utils/apollo/useApollo");
var _dealerDetails = _interopRequireDefault(require("./dealer-details"));
var _map = _interopRequireDefault(require("./map/map"));
var _miniDealerLocator2 = _interopRequireDefault(require("./mini-dealer-locator.css"));
var _commonSetLocation = require("@mmc/common-set-location");
var _CommonLoader;
/* eslint-disable react/no-unused-state */
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LOCATION_SEARCH_QUERY = 'googleLocationSearchQuery';
var ZIP_CODE = 'zipCode';
var noDealersFound = function noDealersFound(state, dealerListLength) {
  var query = state.query,
    location = state.location,
    submittedLocation = state.submittedLocation;
  return submittedLocation && (query.length > 0 || location !== undefined) && dealerListLength <= 0;
};
exports.noDealersFound = noDealersFound;
var getInputMessages = function getInputMessages(dealers, state, props) {
  var geoCodeError = state.geoCodeError,
    searchError = state.searchError;
  var data = props.data,
    errorMessages = props.errorMessages,
    selectedVehicle = props.selectedVehicle;
  var noGeolocationMessage = data.noGeolocationMessage,
    noDealershipFoundMessage = data.noDealershipFoundMessage,
    requiredMessage = data.requiredMessage,
    invalidZipCodeMessage = data.invalidZipCodeMessage,
    isFilterDealersBySelectedVehicle = data.isFilterDealersBySelectedVehicle,
    vehicleUnavailableErrorMessage = data.vehicleUnavailableErrorMessage;
  var messages = [];
  if (geoCodeError && noGeolocationMessage) {
    messages.push({
      body: noGeolocationMessage,
      type: 'error'
    });
  }
  if (invalidZipCodeMessage) {
    messages.push({
      body: invalidZipCodeMessage,
      type: 'error'
    });
  }
  if (errorMessages && errorMessages[0] === 'requiredMessage') {
    messages.push({
      body: requiredMessage,
      type: 'error'
    });
  } else if (errorMessages && errorMessages[1] && messages.length === 0) {
    messages.push({
      body: errorMessages[1],
      type: 'error'
    });
  }
  if (searchError || noDealersFound(state, dealers.length)) {
    if (!searchError && noDealersFound(state, dealers.length) && isFilterDealersBySelectedVehicle && selectedVehicle && selectedVehicle[0]) {
      messages.push({
        body: vehicleUnavailableErrorMessage,
        type: 'error'
      });
    } else {
      messages.push({
        body: noDealershipFoundMessage,
        type: 'error'
      });
    }
  }
  return messages;
};
exports.getInputMessages = getInputMessages;
var checkForMobileAgent = function checkForMobileAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};
exports.checkForMobileAgent = checkForMobileAgent;
var MiniDealerLocator = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(MiniDealerLocator, _React$PureComponent);
  // All components need a resourceType in order for AEM to be aware of its existence
  MiniDealerLocator.resourceType = function resourceType() {
    return 'MiniDealerLocator_1_0_0';
  };
  function MiniDealerLocator(props) {
    var _props$data;
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.dealersListRef = /*#__PURE__*/_react["default"].createRef();
    var storedQuery = _this.getStoredQuery();
    _this.state = {
      location: null,
      stateCode: null,
      query: props.value || storedQuery,
      geoCodeError: false,
      searchError: false,
      submittedLocation: null,
      storedValue: null,
      mobileShowMap: false,
      selectedDealer: null,
      departmentstoUseForHours: null,
      departmentsCode: null,
      hideDealerDetails: true,
      showListMapSearch: true,
      showDealersDetailsThumbnail: false,
      isMobile: false,
      isMapEnabled: props == null ? void 0 : (_props$data = props.data) == null ? void 0 : _props$data.enableViewMap
    };
    var query = _this.state.query;
    _this.search(query);
    _this.handleDealerChange = _this.handleDealerChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.search = _this.search.bind((0, _assertThisInitialized2["default"])(_this));
    _this.queryChange = _this.queryChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearErrors = _this.clearErrors.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateLocation = _this.updateLocation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateStateCode = _this.updateStateCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateLocationError = _this.updateLocationError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateMobileShowMap = _this.updateMobileShowMap.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getDealerSelected = _this.getDealerSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.markerSelected = _this.markerSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getDealerDepartment = _this.getDealerDepartment.bind((0, _assertThisInitialized2["default"])(_this));
    _this.confirmDealer = _this.confirmDealer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.editHandler = _this.editHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleListMapSearch = _this.toggleListMapSearch.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeDealerConfirmation = _this.closeDealerConfirmation.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = MiniDealerLocator.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleWindowResize);
      this.handleWindowResize();
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
      id = _this$props.id,
      selectedVehicle = _this$props.selectedVehicle,
      handleFieldChange = _this$props.handleFieldChange,
      value = _this$props.value;
    if (!(0, _isEqual2["default"])(prevProps.selectedVehicle, selectedVehicle)) {
      this.setState({
        storedValue: value
      });
      handleFieldChange(id, '');
    }
  };
  _proto.handleWindowResize = function handleWindowResize() {
    var width = 0;
    var isMobileAgent = false;
    if (typeof window !== 'undefined') {
      width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
      isMobileAgent = checkForMobileAgent();
    }
    if (width < 768 && isMobileAgent) {
      this.setState({
        isMobile: true
      });
    } else {
      this.setState({
        isMobile: false
      });
    }
  };
  _proto.handleDealerChange = function handleDealerChange(selectedDealers) {
    var _this$props2 = this.props,
      id = _this$props2.id,
      updateErrors = _this$props2.updateErrors,
      handleFieldChange = _this$props2.handleFieldChange,
      handleFieldBlur = _this$props2.handleFieldBlur;
    handleFieldChange(id, selectedDealers, 'dealer-info');
    updateErrors(id, ['', '']);
    if (handleFieldBlur) {
      handleFieldBlur(selectedDealers, id, ['', '']);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  ;
  _proto.getStoredQuery = function getStoredQuery() {
    var storedLocation = (0, _commonSetLocation.getCachedLocation)();
    return storedLocation ? storedLocation.searchValue : '';
  };
  _proto.getDealerSelected = function getDealerSelected(dealer) {
    var isMapEnabled = this.state.isMapEnabled;
    this.setState({
      selectedDealer: dealer
    });
    if (isMapEnabled) {
      this.setState({
        hideDealerDetails: true,
        showListMapSearch: false,
        showDealersDetailsThumbnail: true
      });
    }
  };
  _proto.getDealerDepartment = function getDealerDepartment(departmentDetails, departmentsCode) {
    this.setState({
      departmentstoUseForHours: departmentDetails,
      departmentsCode: departmentsCode
    });
  };
  _proto.updateLocation = function updateLocation(position, stateCode) {
    var _this$props3 = this.props,
      id = _this$props3.id,
      handleFieldChange = _this$props3.handleFieldChange,
      updateErrors = _this$props3.updateErrors;
    if (updateErrors) {
      updateErrors([0], ['', '']);
    }
    this.setState({
      location: position,
      stateCode: stateCode,
      geoCodeError: false,
      searchError: false,
      submittedLocation: true
    }, function () {
      return handleFieldChange(id, '');
    });
  };
  _proto.updateLocationError = function updateLocationError() {
    return this.setState({
      geoCodeError: true
    });
  };
  _proto.updateStateCode = function updateStateCode(code) {
    this.setState({
      stateCode: code
    });
  };
  _proto.checkIfStoredValueIsAvailable = function checkIfStoredValueIsAvailable(dealers) {
    var storedValue = this.state.storedValue;
    var storedDealerId = storedValue && storedValue[0] ? storedValue[0].split('|')[0] : null;
    if (storedDealerId && dealers.find(function (dealer) {
      return String(dealer.id) === String(storedDealerId);
    })) {
      var _this$props4 = this.props,
        id = _this$props4.id,
        handleFieldChange = _this$props4.handleFieldChange;
      handleFieldChange(id, storedValue);
    }
  };
  _proto.queryChange = function queryChange(query) {
    var _this$props5 = this.props,
      handleFieldChange = _this$props5.handleFieldChange,
      id = _this$props5.id;
    this.setState({
      query: query
    }, function () {
      if (!query || query === ' ') {
        handleFieldChange(id, '');
      }
    });
  };
  _proto.search = function search(query) {
    var _this2 = this;
    var _this$props6 = this.props,
      googleAPIKeyFromConfig = _this$props6.googleAPIKeyFromConfig,
      market = _this$props6.market;

    // check to see if query is empty and throw the nodealerfound error??
    if (query && query.length > 0) {
      _DealerLocatorTools["default"].geocode({
        query: query,
        successCallback: function successCallback(position, stateCode, postalCode, city) {
          var locationData = {
            searchValue: query,
            userLocation: position,
            stateCode: stateCode,
            postalCode: postalCode,
            city: city
          };
          _commonLibs.EventEmitter.dispatch('locationChangeEvent', locationData);
          if (!postalCode) {
            _this2.retryGeocodeWithLatlng(position.lat, position.lng);
          }
          _this2.updateLocation(position);
          _this2.updateStateCode(stateCode);
        },
        errorCallback: function errorCallback() {
          return _this2.setState({
            searchError: true
          });
        },
        googleAPIKeyFromConfig: googleAPIKeyFromConfig,
        region: market
      });
    }
  };
  _proto.retryGeocodeWithLatlng = function retryGeocodeWithLatlng(lat, lng) {
    var latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    var lookup = {
      latLng: latLng
    };
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(lookup, function (results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        var postalCode = (0, _commonSetLocation.getPostalCodeFromGooglePlaceResults)(results);
        (0, _commonSetLocation.setUpdatedPostalCodeInCachedLocation)(postalCode);
      }
    });
  };
  _proto.clearErrors = function clearErrors() {
    this.setState({
      geoCodeError: false,
      searchError: false,
      submittedLocation: false
    });
    _jsCookie["default"].remove(LOCATION_SEARCH_QUERY);
    _jsCookie["default"].remove(ZIP_CODE);
  };
  _proto.updateMobileShowMap = function updateMobileShowMap(bool) {
    return this.setState({
      mobileShowMap: bool
    });
  };
  _proto.markerSelected = function markerSelected(dealer) {
    var value = (0, _dealersList.getDealerId)(dealer);
    var event = {
      target: {
        value: value
      }
    };
    this.dealersListRef.current.handleDealerChange(event);
  };
  _proto.confirmDealer = function confirmDealer() {
    this.setState({
      showDealersDetailsThumbnail: false,
      hideDealerDetails: false
    });
  };
  _proto.editHandler = function editHandler() {
    this.setState({
      mobileShowMap: false
    });
    this.dealersListRef.current.toggleDetails();
  };
  _proto.toggleListMapSearch = function toggleListMapSearch() {
    var showListMapSearch = this.state.showListMapSearch;
    var _this$props7 = this.props,
      id = _this$props7.id,
      handleFieldChange = _this$props7.handleFieldChange;
    this.setState({
      showListMapSearch: !showListMapSearch,
      selectedDealer: null
    }, function () {
      return handleFieldChange(id, '');
    });
  };
  _proto.closeDealerConfirmation = function closeDealerConfirmation() {
    this.setState({
      showDealersDetailsThumbnail: false,
      showListMapSearch: true,
      selectedDealer: null
    });
  };
  _proto.sortFilterDealers = function sortFilterDealers(dealers) {
    var _this$props8 = this.props,
      data = _this$props8.data,
      measurementSystem = _this$props8.measurementSystem,
      useLocation = _this$props8.useLocation,
      market = _this$props8.market;
    var initialDealers = data.initialDealers,
      advanceFilter = data.advanceFilter,
      limitReturningDealers = data.limitReturningDealers;
    var location = this.state.location;
    if (location && useLocation) {
      var sortedDealersList = _DealerLocatorTools["default"].listByDistance(dealers, location, measurementSystem, market) || [];
      return advanceFilter ? sortedDealersList.slice(0, limitReturningDealers) : sortedDealersList;
    }
    if (!location && (initialDealers == null ? void 0 : initialDealers.length) > 0) {
      var _formattedDealers = _DealerLocatorTools["default"].formatDealers(initialDealers, market);
      return advanceFilter ? _formattedDealers.slice(0, limitReturningDealers) : _formattedDealers;
    }
    var formattedDealers = _DealerLocatorTools["default"].formatDealers(dealers, market);
    return advanceFilter ? formattedDealers.slice(0, limitReturningDealers) : formattedDealers;
  };
  _proto.redirectToClickshop = function redirectToClickshop() {
    var data = this.props.data;
    var cta = data.cta;
    var urlParams = new URLSearchParams(window.location.search);
    var ctaUrl = new URL(cta.url);
    ctaUrl.search = urlParams;
    var formattedUrl = (0, _commonLibs.setParamsForClickshopUrl)(ctaUrl.href);
    cta.url = formattedUrl.href;
    window.location = cta.url;
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$state = this.state,
      location = _this$state.location,
      query = _this$state.query,
      storedValue = _this$state.storedValue,
      mobileShowMap = _this$state.mobileShowMap,
      showListMapSearch = _this$state.showListMapSearch,
      hideDealerDetails = _this$state.hideDealerDetails,
      selectedDealer = _this$state.selectedDealer,
      showDealersDetailsThumbnail = _this$state.showDealersDetailsThumbnail,
      departmentstoUseForHours = _this$state.departmentstoUseForHours,
      departmentsCode = _this$state.departmentsCode,
      isMobile = _this$state.isMobile,
      isMapEnabled = _this$state.isMapEnabled,
      stateCode = _this$state.stateCode;
    var _this$props9 = this.props,
      data = _this$props9.data,
      theme = _this$props9.theme,
      googleAPIKeyFromConfig = _this$props9.googleAPIKeyFromConfig,
      distance = _this$props9.distance,
      defaultLatitude = _this$props9.defaultLatitude,
      defaultLongitude = _this$props9.defaultLongitude,
      initialRadius = _this$props9.initialRadius,
      market = _this$props9.market,
      multiSelect = _this$props9.multiSelect,
      language = _this$props9.language,
      measurementSystem = _this$props9.measurementSystem,
      skipServerRendering = _this$props9.skipServerRendering,
      selectedVehicle = _this$props9.selectedVehicle,
      className = _this$props9.className,
      value = _this$props9.value,
      path = _this$props9.path;
    var title = data.title,
      subHeadline = data.subHeadline,
      searchHelpText = data.searchHelpText,
      showRating = data.showRating,
      locationCtaLabel = data.locationCtaLabel,
      viewMoreText = data.viewMoreText,
      unitType = data.unitType,
      isFilterDealersBySelectedVehicle = data.isFilterDealersBySelectedVehicle,
      initialDealers = data.initialDealers,
      listLabel = data.listLabel,
      mapLabel = data.mapLabel,
      saleOpeningHoursLabel = data.saleOpeningHoursLabel,
      serviceOpeningHoursLabel = data.serviceOpeningHoursLabel,
      salesLabel = data.salesLabel,
      servicesLabel = data.servicesLabel,
      selectedLabel = data.selectedLabel,
      editLabel = data.editLabel,
      cta = data.cta,
      isWrapped = data.isWrapped;
    var vehicle = '';
    if (selectedVehicle && selectedVehicle.length > 0 && isFilterDealersBySelectedVehicle) {
      vehicle = selectedVehicle[0];
    }
    var queryParams = {
      latitude: location ? location.lat : defaultLatitude,
      longitude: location ? location.lng : defaultLongitude,
      radius: data.searchRadius || initialRadius,
      service: data.preSelectedFilter || 'sales',
      market: market,
      language: language,
      vehicle: vehicle,
      path: path
    };
    if (market === 'ca') {
      queryParams.province = stateCode;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: !isWrapped ? _miniDealerLocator2["default"].formWidth : ''
    }, /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: skipServerRendering
    }, /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: _DealerLocatorTools["default"].query(),
      variables: queryParams,
      onCompleted: function onCompleted(_ref) {
        var searchDealer = _ref.searchDealer;
        var dealers = searchDealer || [];
        if (storedValue !== null && value === '') {
          _this3.checkIfStoredValueIsAvailable(dealers);
        }
      }
    }, function (_ref2) {
      var _dealers;
      var queryData = _ref2.data,
        loading = _ref2.loading;
      var dealers = queryData && queryData.searchDealer || [];
      dealers = _this3.sortFilterDealers(dealers);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className + " " + _miniDealerLocator2["default"].mdlComponent,
        automation: "mini-dealer-locator"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _miniDealerLocator2["default"].mdlContainer
      }, loading && location && (_CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null))), title && /*#__PURE__*/_react["default"].createElement("h3", {
        className: _miniDealerLocator2["default"].title
      }, title), subHeadline && /*#__PURE__*/_react["default"].createElement("h4", {
        className: _miniDealerLocator2["default"].headline
      }, subHeadline), showListMapSearch && /*#__PURE__*/_react["default"].createElement(_inputSearchAutocomplete["default"], {
        onSearch: _this3.search,
        onChange: _this3.queryChange,
        label: searchHelpText,
        value: query,
        theme: theme,
        googleAPIKeyFromConfig: googleAPIKeyFromConfig,
        locationCtaLabel: locationCtaLabel,
        onClear: _this3.clearErrors,
        market: market,
        messages: !loading && getInputMessages(dealers, _this3.state, _this3.props),
        onUseLocationSuccess: _this3.updateLocation,
        onUseLocationError: _this3.updateLocationError,
        language: language,
        isMapEnabled: isMapEnabled
      }), showListMapSearch && isMapEnabled && ((_dealers = dealers) == null ? void 0 : _dealers.length) > 0 && /*#__PURE__*/_react["default"].createElement(_searchDealershipsListToggle["default"], {
        mobileShowMap: mobileShowMap,
        theme: theme,
        updateMobileShowMap: _this3.updateMobileShowMap,
        listLabel: listLabel || 'list',
        mapLabel: mapLabel || 'map'
      }), dealers.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: isMapEnabled ? _miniDealerLocator2["default"].appContainer : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: isMapEnabled ? _miniDealerLocator2["default"].consoleContainer : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + (mobileShowMap ? _miniDealerLocator2["default"].hiddenContainer : '')
      }, !loading && ((initialDealers == null ? void 0 : initialDealers.length) > 0 || dealers.length > 0 || location !== null) && /*#__PURE__*/_react["default"].createElement(_dealersList["default"], {
        value: value,
        initialDealers: initialDealers || [],
        dealers: dealers,
        showRating: showRating,
        multiSelect: data.multiSelect || multiSelect,
        distance: distance,
        unitType: unitType,
        location: location,
        viewMoreText: viewMoreText,
        measurementSystem: measurementSystem,
        onChange: _this3.handleDealerChange,
        theme: theme,
        market: market,
        path: path,
        language: language,
        getDealerSelected: _this3.getDealerSelected,
        getDealerDepartment: function getDealerDepartment() {
          return _this3.getDealerDepartment;
        },
        ref: _this3.dealersListRef,
        toggleListMapSearch: _this3.toggleListMapSearch,
        isMapEnabled: isMapEnabled,
        isMobile: isMobile,
        selectedLabel: selectedLabel,
        editLabel: editLabel,
        salesLabel: salesLabel,
        servicesLabel: servicesLabel,
        saleOpeningHoursLabel: saleOpeningHoursLabel,
        serviceOpeningHoursLabel: serviceOpeningHoursLabel
      }))), isMapEnabled && /*#__PURE__*/_react["default"].createElement("div", {
        className: isMapEnabled ? _miniDealerLocator2["default"].mapContainer + " " + (mobileShowMap || !!selectedDealer ? '' : _miniDealerLocator2["default"].hiddenContainer) : ''
      }, /*#__PURE__*/_react["default"].createElement(_GoogleMapsProvider["default"]
      // Need overrideGoogleMapsApiKey in order to test locally because state.Config.googleApiKey does not have local permissions
      , {
        overrideGoogleMapsApiKey: googleAPIKeyFromConfig
      }, /*#__PURE__*/_react["default"].createElement(_useApollo.ApolloProvider, null, /*#__PURE__*/_react["default"].createElement(_useTabs.TabsProvider, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_map["default"], {
        dealers: dealers,
        query: query,
        location: location,
        market: market,
        language: language,
        value: value,
        selectedDealer: selectedDealer,
        markerSelected: _this3.markerSelected,
        defaultLatitude: defaultLatitude,
        defaultLongitude: defaultLongitude
      }))))), hideDealerDetails ? isMobile && selectedDealer && showDealersDetailsThumbnail && /*#__PURE__*/_react["default"].createElement("div", {
        className: _miniDealerLocator2["default"].dealersDetailsContainer
      }, /*#__PURE__*/_react["default"].createElement("h2", null, selectedDealer.name), /*#__PURE__*/_react["default"].createElement("p", null, selectedDealer.address), /*#__PURE__*/_react["default"].createElement("div", {
        className: _miniDealerLocator2["default"].crossButton
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: _this3.closeDealerConfirmation,
        "aria-label": "clear button"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: theme.mmcIconClose
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _miniDealerLocator2["default"].selectButtonContainer
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        clickEvent: _this3.confirmDealer,
        data: {
          label: 'select',
          priority: 'lowIcon',
          icon: 'ChevronDown'
        },
        iconRight: true,
        theme: theme
      }))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_dealerDetails["default"], {
        dealerName: selectedDealer == null ? void 0 : selectedDealer.name,
        dealerAddress: selectedDealer == null ? void 0 : selectedDealer.address,
        dealerDepartments: departmentstoUseForHours,
        theme: theme,
        departmentsCode: departmentsCode,
        editHandler: _this3.editHandler,
        selectedLabel: selectedLabel,
        editLabel: editLabel,
        salesLabel: salesLabel,
        servicesLabel: servicesLabel,
        saleOpeningHoursLabel: saleOpeningHoursLabel,
        serviceOpeningHoursLabel: serviceOpeningHoursLabel
      })))), cta && cta.url && /*#__PURE__*/_react["default"].createElement("div", {
        className: _miniDealerLocator2["default"].ctaWrapper
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        data: {
          label: cta.label,
          openNewTab: cta.openNewTab,
          priority: cta.priority
        },
        disabled: !selectedDealer,
        classes: [_miniDealerLocator2["default"].lowIconCta],
        clickEvent: function clickEvent() {
          return _this3.redirectToClickshop();
        }
      }))));
    })));
  };
  return MiniDealerLocator;
}(_react["default"].PureComponent);
MiniDealerLocator.displayName = 'MiniDealerLocator';
MiniDealerLocator.defaultProps = {
  skipServerRendering: true,
  multiSelect: false,
  useLocation: true,
  updateErrors: function updateErrors() {
    return undefined;
  },
  handleFieldChange: function handleFieldChange() {
    return undefined;
  }
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyFormat: state.Config.currencyFormat,
    defaultLang: state.Config.defaultLang,
    measurementSystem: state.Config.measurementSystem,
    googleAPIKeyFromConfig: state.Config.googleApiKey,
    market: state.Config.market,
    language: state.Config.language,
    dateFormat: state.Config.dateFormat,
    localeCode: state.Config.localeCode,
    distance: state.Config.distance,
    defaultMapZoom: state.Config.defaultMapZoom,
    initialRadius: state.Config.initialRadius,
    defaultLatitude: state.Config.defaultLatitude,
    defaultLongitude: state.Config.defaultLongitude
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(MiniDealerLocator);
exports["default"] = _default;